import React, { useReducer } from "react";
import { INITIAL_FORM, UPDATE_COMPONENT, UPDATE_FORM, } from "../../constants/common";
import FormContext from "./form-context";
import formReducer from "./form-reducer";
var FormState = function (_a) {
    var children = _a.children;
    var _b = useReducer(formReducer, INITIAL_FORM), formState = _b[0], dispatch = _b[1];
    var updateForm = function (data) {
        dispatch({ type: UPDATE_FORM, payload: data });
    };
    var updateComponent = function (data) {
        dispatch({ type: UPDATE_COMPONENT, payload: data });
    };
    return (React.createElement(FormContext.Provider, { value: { form: formState, updateForm: updateForm, updateComponent: updateComponent } }, children));
};
export default FormState;
//# sourceMappingURL=FormState.js.map